// Styles here will override Bulma styles
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const StyledContent = styled.p`
  display: block;
  font-size: 16px;
  line-height: 26px;
  margin: 15px 0 25px 0;
  color: #5b6987 !important;

  &.featured {
    margin: 15px 0 15px 0;
    display: flex;
  }

  ${media('<desktop')} {
    display: none;
  }
`;
